import {
    BillTo,
    Certification,
    Informant,
    Invoices,
    LegacyDocuments,
    PurchaseOrders,
    RefreshmentsVenue
} from '../FuneralFragments';
import { buildTabDataFragment } from '../../../util/functions';
import gql from 'graphql-tag';
import Disposal from '../../fragments/Disposal';
import { AllSuppliers } from '../../fragments/Bookings';

export default buildTabDataFragment(
    [
        gql`
            fragment BillingFields on Funeral {
                ApplicantGivenName
                ApplicantMiddleName
                ApplicantSurname

                FollowUpRating
                FollowUpComment
                FollowUpCallMade
                FollowUpSatisfaction
                FollowUpCallMadeDatetime

                Cancelled
                CancelledDate
                CancelledReason

                DepositReceived
                DepositAmount

                BillingNotes
                DateOfService

                Enquiry {
                    ID
                }

                ...PurchaseOrders
            }
        `,
        AllSuppliers,
        BillTo,
        Certification,
        Disposal,
        Informant,
        Invoices,
        LegacyDocuments,
        PurchaseOrders,
        RefreshmentsVenue
    ],
    'Funeral'
);
